// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__3SgGS","circle":"Loading_circle__3zRhK","jump":"Loading_jump__1k0Cy"};